import qs from 'qs';
import BaseHttp from '@/plugins/baseHttp';

const getCities = ({franchises, page, search, size, from,},) => {
  size = size || 15;
  if(typeof from === 'undefined') {
    from = ((page || 1) - 1) * size;
  }

  const queryObj = {
    size: size,
    from: from,
    search: search ? `${search}` : undefined,
  };

  const query = `/address/cities/franchises?id=${franchises}&${qs.stringify(queryObj,)}`;

  return BaseHttp.get(query,);
};

const getCompanies = ({franchises, page, search, size, from, cities,},) => {
  size = size || 15;
  if(typeof from === 'undefined') {
    from = ((page || 1) - 1) * size;
  }

  const queryObj = {
    size: size,
    from: from,
    search: search ? `${search}` : undefined,
  };
  const query = `/companies/franchises?id=${franchises}&cities=${cities}&${qs.stringify(queryObj,)}`;

  return BaseHttp.get(query,);
};

const getCompanyCampaigns = ({
  campaignId,
  cities,
  type,
  from,
  size,
  company_name,
},) => {
  const queryData = {
    type: type || null,
    from: from || 0,
    size: size || 15,
    company_name: company_name || null,
  };

  const query = `/company/campaign?campaign_id=${campaignId}&cities=${cities}&${qs.stringify(queryData,)}`;

  return BaseHttp.get(query,);
};

const createBound = (bound,) => {
  return BaseHttp.post('/company/campaign', bound,);
};

const updateBound = (bound,) => {
  return BaseHttp.put('/company/campaign', bound,);
};

const deleteCampaigns = ({ campaignId, bounds, },)=> {
  const body = {
    data: {
      campaign_id: campaignId,
      company_campaign_ids: bounds,
    },
  };

  return BaseHttp.delete('/company/campaign', body,);
};

const deleteCampaign = ({ campaignId, },) => {
  const query = `/company/campaign/${campaignId}`;

  return BaseHttp.delete(query,);
};

const toggleCampaignStatus = ({ campaignId, type, },) => {
  const query = `/company/campaign/${type}/${campaignId}`;

  return BaseHttp.post(query,);
};

export default{
  getCities,
  getCompanies,
  getCompanyCampaigns,
  createBound,
  updateBound,
  deleteCampaigns,
  deleteCampaign,
  toggleCampaignStatus,
};
